import { useEffect } from 'react';
import { getEnv } from 'utils';

export default function PlasreconsurgPage() {
  useEffect(() => {
    window.location.href = `${getEnv('MTG_URL_PUBLISHERS')}/plastic-reconstructive-surgery`;
  }, []);
}
